module.exports = __webpack_public_path__ + "img/img34.85e9fd41.svg";